import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Hero } from "@/components/Hero";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/**
 * Landing Page Component
 * 
 * Main entry point featuring:
 * - Clean navigation with hamburger menu for secondary actions
 * - Single focused CTA (Join Waitlist)
 * - Clear value proposition and target market messaging
 * - Streamlined user experience focused on conversion
 * 
 * @returns {JSX.Element} Landing page component
 */
const Landing = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <main className="min-h-screen">
      <div className="container mx-auto px-4">
        <nav className="py-4 flex justify-between items-center">
          {/* Brand Logo */}
          <div className="text-3xl font-extrabold tracking-tight text-primary">Centse</div>
          
          {/* Desktop Navigation - Show all buttons */}
          <div className="hidden md:flex items-center space-x-6">
            <Button
              variant="ghost"
              onClick={() => navigate("/who-we-are")}
              className="text-muted-foreground hover:text-foreground"
            >
              Who We Are
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate("/how-it-works")}
              className="text-muted-foreground hover:text-foreground"
            >
              How It Works
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate("/login")}
            >
              Log in
            </Button>
            <Button
              onClick={() => navigate("/signup")}
            >
              Sign up
            </Button>
          </div>

          {/* Mobile Navigation - Hamburger menu only */}
          <div className="md:hidden">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="p-2">
                  <Menu className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuItem onClick={() => navigate("/who-we-are")}>
                  Who We Are
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/how-it-works")}>
                  How It Works
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate("/login")}>
                  Log in
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/signup")}>
                  Sign up
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </nav>
      </div>
      <Hero />
    </main>
  );
};

export default Landing;